<template>
  <div class="blocco_sfumato cf cancel-button">
    <div class="titolo title">Abbonamenti Riviste</div>
    <div class="row-fluid">
      <DxDataGrid
        :data-source="journals"
        :allow-column-reordering="true"
        :repaint-changes-only="true"
        :remote-operations="true"
      >
        <DxPager
          :show-page-size-selector="true"
          :allowed-page-sizes="[10, 20, 50]"
          :show-navigation-buttons="true"
          :show-info="true"
          :info-text="'Pagina {0} di {1} ({2} elementi)'"
        />
        <DxPaging :page-size="10"></DxPaging>
        <DxColumn data-field="title" caption="Titolo" width="40%"></DxColumn>
        <DxColumn
          alignment="center"
          data-type="date"
          data-field="startDate"
          format="dd/MM/yyyy"
          caption="Data Inizio Abbonamento"
          width="15%"
        ></DxColumn>
        <DxColumn
          alignment="center"
          data-field="clientName"
          caption="Cliente Intestatario"
          width="30%"
        ></DxColumn>
        <DxColumn
          alignment="center"
          caption="Accedi"
          data-field="rowId"
          cell-template="loadButton"
          width="15%"
        ></DxColumn>
        <template #loadButton="{ data }">
          <div>
            <DxButton
              :width="90"
              styling-mode="contained"
              text="ACCEDI"
              type="default"
              @click="loadJournal(data)"
            >
            </DxButton>
          </div>
        </template>
      </DxDataGrid>
    </div>
  </div>
</template>

<script>
import { buildODataSorting } from '@/common/odataParser'
import CustomStore from 'devextreme/data/custom_store'
import {
  DxDataGrid,
  DxColumn,
  DxPaging,
  DxPager,
} from 'devextreme-vue/data-grid'
import DxButton from 'devextreme-vue/button'

export default {
  name: 'EcJournalsSubscriptionsGrid',
  components: {
    DxDataGrid,
    DxColumn,
    DxPaging,
    DxButton,
    DxPager,
  },
  data() {
    return {
      journals: new CustomStore({
        load: loadOptions => {
          // eslint-disable-next-line no-undef
          var deferred = $.Deferred()

          const params = {
            $top: loadOptions.take,
            $skip: loadOptions.skip,
            $orderby: buildODataSorting(loadOptions.sort),
          }

          this.apiService.journalsApi
            .getJournalsSubscriptionsAggregatedOdata(params)
            .then(res => {
              deferred.resolve({ data: res.items, totalCount: res.count })
            })
          return deferred.promise()
        },
      }),
    }
  },
  methods: {
    loadJournal(data) {
      this.apiService.journalsApi.openJournalbyRowId(data.value).then(res => {
        var url = window.location.origin + res
        window.open(url, '_blank')
      })
    },
  },
}
</script>
